.popover {
  width: var(--size-popover);
  padding: var(--space-3);
}
